<div class="mgo-location-search-detail">
  <h4 class="mat-h5 header">{{ labels?.depositLocation }}</h4>

  <div
    class="deposit-location"
    *ngIf="locationFinderService?.selectedLocation$ | async as selectedLocation"
  >
    <div class="map-finder">
      <app-location-map
        [flow]="flow"
        [google]="google"
        [labels]="sdfCardLabels"
        [pinLocation]="pinSelectedLocation"
      >
      </app-location-map>
    </div>
    <div class="location-details">
      <div>
        <p class="text-business-name">
          {{ selectedLocation?.locationDetails?.name }}
        </p>
        <p class="text-address">
          {{
            locationFinderService.getFormattedAddress({
              addressLine1: selectedLocation?.locationDetails?.addressLine1!,
              addressLine2: selectedLocation?.locationDetails?.addressLine2!,
              addressLine3: selectedLocation?.locationDetails?.addressLine3!
            })
          }}<br />
          {{
            locationFinderService.getFormattedAddress({
              city: selectedLocation?.locationDetails?.city!,
              state: selectedLocation?.locationDetails?.state!,
              postalCode: selectedLocation?.locationDetails?.postalCode!,
              zipCode: selectedLocation?.locationDetails?.zipCode!
            })
          }}
          <br />
          {{ selectedLocation?.locationPhone?.phone! }}
        </p>
      </div>
      <ng-container>
        <app-location-services
          [labels]="labels"
          [locationServices]="selectedLocation?.locationServices"
        ></app-location-services>
      </ng-container>
      <ng-container>
        <app-location-closing-hour
          [labels]="labels"
          [businessHours]="selectedLocation?.locationOperatingHours!"
        ></app-location-closing-hour>
      </ng-container>
      <div class="a-link" *ngIf="showChangeLocator">
        <a href="javascript:void(0)" (click)="goToLocatorPage()" tabindex="0">{{
          labels?.changeLocation
        }}</a>
      </div>
    </div>
  </div>
</div>
